module.exports = __webpack_public_path__ + "media/images/ecalls/icon_chevron_down_ice-680a97fc2f3a112371b137e9ee299a3e.png";